/**
 * LockedPage — statyczna strona pokazywana użytkownikom gdy Creator Lock ON
 * i user nie jest adminem (albo w ogóle nie zalogowany).
 *
 * Nie jest 500. Nie jest Cloudflare error. Nie jest JSON. To elegancki
 * placeholder z brandingiem PAX komunikujący że aplikacja jest w zamkniętych
 * testach.
 *
 * UX:
 * - Duże logo PAX / kłódka.
 * - Krótki komunikat po polsku.
 * - Zero CTA (żadnego formularza zapisów w P0 — user zdecydował że później).
 * - Link „Wróć do strony głównej" (na wypadek dostania się tu przypadkiem).
 */
import { Lock } from "lucide-react";

const LockedPage = () => {
  return (
    <div
      className="min-h-screen bg-gradient-to-br from-[#0F1F3D] via-[#0F1F3D] to-[#1a2f5d] flex items-center justify-center px-4"
      data-testid="locked-page"
    >
      <div className="max-w-lg w-full text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-white/5 backdrop-blur border border-white/10 mb-8">
          <Lock className="w-10 h-10 text-white/90" strokeWidth={1.6} />
        </div>

        <h1
          className="text-5xl font-bold text-white tracking-tight mb-6"
          data-testid="locked-page-title"
        >
          PAX
        </h1>

        <div className="space-y-4 text-white/80 text-base leading-relaxed">
          <p data-testid="locked-page-message-1">
            System jest obecnie dostępny wyłącznie dla&nbsp;zamkniętej grupy
            testerów.
          </p>
          <p data-testid="locked-page-message-2">
            Trwają testy wersji <span className="font-semibold text-white">beta</span>.
          </p>
          <p className="text-white/60 text-sm pt-4" data-testid="locked-page-message-3">
            Obserwuj rozwój projektu.
          </p>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10">
          <div
            className="inline-flex items-center gap-2 text-[11px] uppercase tracking-widest text-white/40"
            data-testid="locked-page-footer"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-amber-400/70 animate-pulse" />
            Closed Beta
          </div>
        </div>
      </div>
    </div>
  );
};

export default LockedPage;
